<template>
  <div class="container">
    <div class="blog-posts-grid">
      <BlogListItem
        v-for="post in latestPosts"
        :key="post.id"
        :post="post"
      />
    </div>
  </div>

  <div class="cont_boxes">
    <div class="text-container">
      <h3 style="color:#6a2481">Agile sin filtros ¿Quiénes somos?</h3>
      <p>Somos un equipo que se junta con ganas de hablar de lo que nos encontramos en la vida real.</p>
      <p>Somos soñadores, retadores, atrevidos y dispuestos a compartirlo contigo y dar un espacio para que tú también compartas.</p>
      <p>Somos el equipo Agile sin filtros.</p>
    </div>
    <div class="text-container">
      <h3 style="color:#6a2481">¿De dónde surge esta idea? </h3>
      <p> Teníamos ganas de hablar, comunicar y compartir…</p>
      <p>¿Cómo lo has hecho tu? los escollos y la resistencia al cambio, todo lo que nos encontramos en las compañías o en los equipos,  pero mejor aún, compartamos herramientas que hemos utilizado para sortear estas situaciones.</p>
      <p>De esta idea surge Agile sin filtros. </p>
    </div>
    <div class="text-container">
      <h3 style="color:#6a2481">Nuestro Objetivo</h3>
      <p>Nuestro objetivo es dar voz y visibilidad a todo el que quiera compartir su experiencia con nosotros.</p>
      <p>Crear una comunidad de colegas fuerte y que se retroalimente, que trabaje en democratizar conocimiento y de esta manera tener muchas opiniones en la comunidad.</p>
    </div>
  </div>
</template>

<script>
import { getBlogPosts } from '../services/blogService';
import BlogListItem from './blog/BlogListItem.vue';

export default {
  components: {
    BlogListItem
  },
  data() {
    return {
      latestPosts: []
    };
  },
  async created() {
    try {
      // Obtener las últimas 10 entradas (página 1, límite 10)
      const response = await getBlogPosts(1, 10);
      this.latestPosts = response.posts; // Asumiendo que la respuesta tiene una propiedad 'posts'
    } catch (error) {
      console.error('Error fetching latest blog posts:', error);
    }
  }
};
</script>

<style scoped>
.container {
  max-width: 1400px; /* Aumentar el ancho máximo para acomodar 5 columnas */
  margin: 0 auto; /* Centra el contenedor */
  padding: 0 15px; /* Añade un poco de padding a los lados para evitar que el contenido toque los bordes en pantallas pequeñas */
}

.blog-posts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); /* Ajusta minmax para el tamaño de las cards y 5 columnas */
  gap: 20px; /* Espacio entre las cards */
  margin-bottom: 20px; /* Espacio debajo de la matriz */
}

/* Ajuste para pantallas más pequeñas */
@media (min-width: 1400px) { /* Para pantallas muy grandes, asegurar 5 columnas */
  .blog-posts-grid {
    grid-template-columns: repeat(5, 1fr);
  }
}

@media (max-width: 1200px) { /* Ajuste para 4 columnas */
  .blog-posts-grid {
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  }
}

@media (max-width: 992px) { /* Ajuste para 3 columnas en pantallas medianas */
  .blog-posts-grid {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }
}

@media (max-width: 768px) { /* Ajuste para 2 columnas en tablets */
  .blog-posts-grid {
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  }
}

@media (max-width: 480px) { /* Ajuste para 1 columna en móviles */
  .blog-posts-grid {
    grid-template-columns: 1fr;
  }
}
</style>